import { Component, OnInit } from '@angular/core';
import { DateModel, DateModelOptions } from '@evorait/pace-core';
import moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { tap } from 'rxjs/operators';
import { MileageModel } from '../../models/mileage.model';
import { MileageService } from '../../services/mileage.service';

@Component({
    selector: 'pace-mileage-history',
    templateUrl: './mileage-history.component.html',
    styleUrls: ['./mileage-history.component.scss'],
})
export class MileageHistoryComponent implements OnInit {
    public mileages: MileageModel[] = [];
    public fieldName = 'statusString.value'; // initially materials should be sorted wrt status
    public reverse = false;
    public isLoading = true;
    public fromDate: DateModel;
    public toDate: DateModel;

    public constructor(
        private readonly mileageService: MileageService,
        public readonly modalInstance: BsModalRef,
    ) {}

    public ngOnInit(): void {
        this.mileageService
            .init()
            .pipe(
                tap((mileages) => {
                    this.mileages = mileages;
                    const minDate = mileages.length > 0 ? mileages[0].recordedDate.clone() : moment().startOf('day');
                    const maxDate =
                        mileages.length > 0
                            ? mileages[mileages.length - 1].recordedDate.clone()
                            : moment().startOf('day');
                    const dateModelOptions = new DateModelOptions({
                        minValue: minDate,
                        maxValue: maxDate,
                    });
                    this.fromDate = new DateModel('FromDate', minDate, dateModelOptions);
                    this.toDate = new DateModel('ToDate', maxDate, dateModelOptions);
                    this.isLoading = false;
                }),
            )
            .subscribe();
    }

    public setOrderBy(field: string): void {
        if (this.fieldName === field) {
            this.reverse = !this.reverse;
        } else {
            this.fieldName = field;
        }
    }

    public filterHistory(): void {
        if (!this.fromDate && !this.toDate) {
            return;
        }
        this.mileages = this.mileageService.filterMileageFromDate(this.fromDate.value, this.toDate.value);
    }
}
